import {
  APS_CLIENT,
  SRP_CLIENT,
  CLECO,
  PSE,
  PSE_CLIENT,
  NRG_CLIENT,
} from 'client'

const dataItemSortIndex = {
  rtLmp: 1,
  genMw: 2,
  daLmp: 3,
  daAwardMw: 4,
  rtRevenue: 5,
  daRevenue: 6,
  regCredit: 7,
  otherCredit1: 8,
  otherCredit2: 9,
  actualRevenue: 10,
  totalGencost: 11,
  startcostShare: 12,
  totalCost: 13,
  actualMargin: 14,
  eventtype: 15,
  causecode: 16,
  targetMw: 17,
  targetRevenue: 18,
  availMw: 19,
  lostMwh: 20,
  lostRevDollar: 21,
  unavailMwCost: 22,
  lostMargin: 23,
  explanation: 24,
  laststartdate: 25,
  startcostType: 26,
  startcost: 27,
  netdepcap: 28,
  ecoMax: 29,
  ecoMin: 30,
  ecomaxrate: 31,
  ecominrate: 32,
  spinResvMw: 33,
  peak: 34,
  opReserveDpmw: 35,
  opReservePct: 36,
}

const SRPDataItemSortIndex = {
  rtLmp: 1,
  ecominrate: 2,
  ecomaxrate: 3,
  genMw: 4,
  actualRevenue: 5,
  totalGencost: 6,
  startcostShare: 7,
  totalCost: 8,
  actualMargin: 9,
  eventtype: 10,
  targetMw: 11,
  targetRevenue: 12,
  availMw: 13,
  lostMwh: 14,
  lostRevDollar: 15,
  unavailMwCost: 16,
  lostMargin: 17,
  explanation: 18,
  startfuelCode: 19,
  pfuelCode: 20,
  laststartdate: 21,
  startcostType: 22,
  startcost: 23,
  netdepcap: 24,
  ecoMax: 25,
  ecoMin: 26,
  spinResvMw: 27,
  peak: 28,
  opReserveDpmw: 29,
  opReservePct: 30,

  // daLmp: 3,
  // daAwardMw: 4,
  // rtRevenue: 5,
  // daRevenue: 6,
  // regCredit: 7,
  // otherCredit1: 8,
  // otherCredit2: 9,
  // causecode: 16,
}

const APSDataItemSortIndex = {
  rtLmp: 1,
  ecominrate: 2,
  ecomaxrate: 3,
  genMw: 4,
  actualRevenue: 5,
  totalGencost: 6,
  startcostShare: 7,
  totalCost: 8,
  actualMargin: 9,
  eventtype: 10,
  targetMw: 11,
  targetRevenue: 12,
  availMw: 13,
  lostMwh: 14,
  lostRevDollar: 15,
  unavailMwCost: 16,
  lostMargin: 17,
  explanation: 18,
  startfuelCode: 19,
  pfuelCode: 20,
  laststartdate: 21,
  startcostType: 22,
  startcost: 23,
  netdepcap: 24,
  ecoMax: 25,
  ecoMin: 26,
  spinResvMw: 27,
  peak: 28,
  opReserveDpmw: 29,
  opReservePct: 30,

  // daLmp: 3,
  // daAwardMw: 4,
  // rtRevenue: 5,
  // daRevenue: 6,
  // regCredit: 7,
  // otherCredit1: 8,
  // otherCredit2: 9,
  // causecode: 16,
}

const PSEDataItemSortIndex = {
  daLmp: 1,
  rtLmp: 2,
  forecastLmp: 3,
  otherCost1: 4,
  genMw: 5,
  actualRevenue: 6,
  totalGencost: 7,
  startcostShare: 8,

  // dispatchMw: 6,
  // demandStatus: 7,
  // noloadCost: 8,
  // regCredit: 9,

  totalCost: 13,
  // totalMargin: 14,
  actualMargin: 15,
  eventtype: 16,
  targetMw: 17,
  targetRevenue: 18,
  availMw: 19,
  lostMwh: 20,
  lostRevDollar: 21,
  unavailMwCost: 22,
  lostMargin: 23,
  explanation: 24,
  startfuelCode: 25,
  pfuelCode: 26,
  laststartdate: 27,
  startcostType: 28,
  startcost: 29,
  netdepcap: 30,
  ecoMax: 31,
  ecoMin: 32,
  spinResvMw: 33,
  peak: 34,
  opReserveDpmw: 35,
  opReservePct: 36,
  ecominrate: 37,
  ecomaxrate: 38,
}

const dataItemMap = {
  rtLmp: 'RT LMP',
  genMw: 'Gen MWH',
  daLmp: 'DA LMP',
  daAwardMw: 'DA Award MW',
  rtRevenue: 'RT Revenue',
  daRevenue: 'DA Revenue',
  // regCredit: 'Reg Credit',
  regCredit: 'Ancillay Credit',
  otherCredit1: 'Make-Whole',
  otherCredit2: 'LMO Adjustment',
  actualRevenue: 'Actual Revenue',
  totalGencost: 'Generation Cost',
  startcostShare: 'Start Cost Share',
  totalCost: 'Total Cost',
  actualMargin: 'Actual Margin',
  eventtype: 'Event Type',
  causecode: 'Cause Code',
  targetMw: 'Target MW',
  // targetRevenue: 'Target Revenue',
  targetRevenue: 'Potential Revenue',
  availMw: 'Avail MW',
  lostMwh: 'Lost MWH',
  lostRevDollar: 'Lost Revenue',
  unavailMwCost: 'Cost of Lost MWH',
  lostMargin: 'Lost Margin',
  explanation: 'Explanation',
  laststartdate: 'Last Start Date',
  startcostType: 'Last Start Type',
  startcost: 'Last Start Cost',
  netdepcap: 'Net Dep Cap',
  ecoMax: 'Eco Max',
  ecoMin: 'Eco Min',
  ecomaxrate: 'Eco Max Rate',
  ecominrate: 'Eco Min Rate',
}

const CLECODataItemMap = {
  rtLmp: 'RT LMP',
  genMw: 'Gen MWH',
  daLmp: 'DA LMP',
  daAwardMw: 'DA Award MW',
  rtRevenue: 'RT Revenue',
  daRevenue: 'DA Revenue',
  // regCredit: 'Reg Credit',
  regCredit: 'Ancillay Credit',
  otherCredit1: 'Make-Whole',
  otherCredit2: 'LMO Adjustment',
  actualRevenue: 'Actual Revenue',
  totalGencost: 'Generation Cost',
  startcostShare: 'Start Cost Share',
  totalCost: 'Total Cost',
  actualMargin: 'Energy Margin',
  eventtype: 'Event Type',
  causecode: 'Cause Code',
  targetMw: 'Target MW',
  // targetRevenue: 'Target Revenue',
  targetRevenue: 'Potential Revenue',
  availMw: 'Avail MW',
  lostMwh: 'Lost MWH',
  lostRevDollar: 'Lost Revenue',
  unavailMwCost: 'Cost of Lost MWH',
  lostMargin: 'Lost Margin',
  explanation: 'Explanation',
  laststartdate: 'Last Start Date',
  startcostType: 'Last Start Type',
  startcost: 'Last Start Cost',
  netdepcap: 'Net Dep Cap',
  ecoMax: 'Eco Max',
  ecoMin: 'Eco Min',
  ecomaxrate: 'Eco Max Rate',
  ecominrate: 'Eco Min Rate',
}

const NRGTrueUpDataItemMap = {
  rtLmp: 'RT LMP',
  genMw: 'Gen MWH',
  daLmp: 'DA LMP',
  daAwardMw: 'DA Award MW',
  rtRevenue: 'RT Revenue',
  daRevenue: 'DA Revenue',
  totalGencost: 'Generation Cost',
  startcostShare: 'Start Cost Share',
  totalCost: 'Total Cost',
  totalCostByGenMW: 'Total Cost ($/MWH)',
  eventtype: 'Event Type',
  causecode: 'Cause Code',
  targetMw: 'Target MW',
  availMw: 'Avail MW',
  lostMwh: 'Lost MWH',
  lostRevDollar: 'Lost Revenue',
  unavailMwCost: 'Cost of Lost MWH',
  unavailMwCostByLost: 'Cost of Lost MWH ($/MWH)',
  euor: 'EUOR MW',
  netdepcap: 'Net Dep Cap',
  ecoMax: 'Eco Max',
  ecoMin: 'Eco Min',
  ecomaxrate: 'Eco Max Rate',
  ecominrate: 'Eco Min Rate',
  plantOverPerformance: 'Plant Over Performance',
  commaOpsEventTrueup: 'CommOps Event True Up',
  commaOpsNonEventTrueup: 'CommOps Non Event True Up',
  commaOpsDAOppotunityLoss: 'CommOps DA Opportunity Loss',
  trueupAdj: 'True Up Adjustment',
  trueUp: 'Total CommOps True up',
  rsMbLofOpportunity: 'RS_MB_LOF Opportunity Loss',
  explanation: 'Explanation',
}

const PSEDataItemMap = {
  rtLmp: 'Hour-Ahead Price',
  daLmp: 'Day-Ahead Price',
  forecastLmp: 'Price Applied',
  ecominrate: 'Eco Min Rate',
  ecomaxrate: 'Eco Max Rate',
  genMw: 'Gen MWh',
  targetMw: 'Target MW',
  // dispatchMw: '"Dispatch MW',
  availMw: 'Avail MW',
  lostMwh: 'Lost MWh',
  lostRevDollar: 'Lost Opp Revenue',
  unavailMwCost: 'Cost of Lost MWh',
  eventtype: 'Event Type',
  // demandStatus: 'Demand Status',
  // noloadCost: 'Noload Cost',
  laststartdate: 'Last Start Date',
  startcostType: 'Last Start Type',
  startcost: 'Last Start Cost',
  startcostShare: 'Start Cost Share',
  totalGencost: 'Generation Cost',
  // totalMargin: 'Total Margin',
  pfuelCode: 'Gen Fuel',
  startfuelCode: 'Start Fuel',
  netdepcap: 'Net Dep Cap',
  ecoMax: 'Eco Max',
  ecoMin: 'Eco Min',
  // regCredit: 'Spin Res. Credit',
  // spinResvMw: 'Spin Resv MW',
  // peak: 'Peak',
  // opReserveDpmw: 'Op Reserve DPMW',
  // opReservePct: 'Op Reserve Pct',
  explanation: 'Explanation',
  targetRevenue: 'Target Revenue',
  actualRevenue: 'Actual Revenue',
  totalCost: 'Total Cost',
  actualMargin: 'Actual Margin',
  lostMargin: 'Lost Opp Margin',
  otherCost1: 'Fuel Price ($/MBTU)',
}

const SRPDataItemMap = {
  rtLmp: 'LMP/Lambda',
  ecominrate: 'Eco Min Rate',
  ecomaxrate: 'Eco Max Rate',
  genMw: 'Gen MWh',
  actualRevenue: 'Actual Revenue',
  totalGencost: 'Generation Cost',
  startcostShare: 'Start Cost Share',
  totalCost: 'Total Cost',
  actualMargin: 'Actual Margin',
  eventtype: 'Event Type',
  targetMw: 'Target MW',
  targetRevenue: 'Target Revenue',
  availMw: 'Avail MW',
  lostMwh: 'Lost MWH',
  lostRevDollar: 'Lost Opp Revenue',
  unavailMwCost: 'Cost of Lost MWH',
  lostMargin: 'Lost Opp Margin',
  explanation: 'Explanation',
  startfuelCode: 'Start Fuel',
  pfuelCode: 'Gen Fuel',
  laststartdate: 'Last Start Date',
  startcostType: 'Last Start Type',
  startcost: 'Last Start Cost',
  netdepcap: 'Net Dep Cap',
  ecoMax: 'Eco Max',
  ecoMin: 'Eco Min',

  // daAwardMw: 'DA Award MW',
  // rtRevenue: 'RT Revenue',
  // daRevenue: 'DA Revenue',
  // // regCredit: 'Reg Credit',
  // regCredit: 'Ancillay Credit',
  // otherCredit1: 'Make-Whole',
  // otherCredit2: 'LMO Adjustment',
  // causecode: 'Cause Code',
}

const APSDataItemMap = {
  rtLmp: 'LMP/Lambda',
  ecominrate: 'Eco Min Rate',
  ecomaxrate: 'Eco Max Rate',
  genMw: 'Gen MWh',
  actualRevenue: 'Actual Revenue',
  totalGencost: 'Generation Cost',
  startcostShare: 'Start Cost Share',
  totalCost: 'Total Cost',
  actualMargin: 'Actual Margin',
  eventtype: 'Event Type',
  targetMw: 'Target MW',
  targetRevenue: 'Target Revenue',
  availMw: 'Avail MW',
  lostMwh: 'Lost MWH',
  lostRevDollar: 'Lost Opp Revenue',
  unavailMwCost: 'Cost of Lost MWH',
  lostMargin: 'Lost Opp Margin',
  explanation: 'Explanation',
  startfuelCode: 'Start Fuel',
  pfuelCode: 'Gen Fuel',
  laststartdate: 'Last Start Date',
  startcostType: 'Last Start Type',
  startcost: 'Last Start Cost',
  netdepcap: 'Net Dep Cap',
  ecoMax: 'Eco Max',
  ecoMin: 'Eco Min',

  // daAwardMw: 'DA Award MW',
  // rtRevenue: 'RT Revenue',
  // daRevenue: 'DA Revenue',
  // // regCredit: 'Reg Credit',
  // regCredit: 'Ancillay Credit',
  // otherCredit1: 'Make-Whole',
  // otherCredit2: 'LMO Adjustment',
  // causecode: 'Cause Code',
}

export const dataItemMapRemaining = {
  // below field is not in  query
  dispatchMw: 'Dispatch MW',
  demandStatus: 'Demand Status',
  noloadCost: 'Noload Cost',
  totalMargin: 'Total Margin',
  pfuelCode: 'Gen Fuel',
  startfuelCode: 'Start Fuel',
  forecastLmp: 'Forecast LMP',
  eventnumber: 'Event Number',
  eventlmp: 'Event LMP',
  cStartcost: 'C Start Cost',
  cStartcostShare: 'C Start Cost Share',
  cTotalGencost: 'C Total Gen Cost',
  spinResvMw: 'Spin Resv MW',
  peak: 'Peak',
  opReserveDpmw: 'Op Reserve DPMW',
  opReservePct: 'Op Reserve Pct',
  regMw: 'Reg MW',
  regMcp: 'Reg MCP',
  spinResvCredit: 'Spin Resv Credit',
  spinResvMcp: 'Spin Resv MCP',
  otherQuantity1: 'Other Quantity 1',
  otherQuantity2: 'Other Quantity 2',
  otherCost1: 'Other Cost 1',
  otherCost2: 'Other Cost 2',
  ownership: 'Ownership',
}

export const getDataItemByClient = (CLIENT, trueup = false) => {
  if (CLIENT === NRG_CLIENT && trueup) return NRGTrueUpDataItemMap
  switch (CLIENT) {
    case SRP_CLIENT:
      return SRPDataItemMap
    case APS_CLIENT:
      return APSDataItemMap
    case CLECO:
    case NRG_CLIENT:
      return CLECODataItemMap
    case PSE:
      return PSEDataItemMap
    default:
      return dataItemMap
  }
}

export const getAllDataItemByClient = (CLIENT, trueup) => {
  if (CLIENT === NRG_CLIENT && trueup)
    return getDataItemByClient(CLIENT, trueup)
  switch (CLIENT) {
    case SRP_CLIENT:
    case APS_CLIENT:
    case CLECO:
    case NRG_CLIENT:
      return { ...dataItemMapRemaining, ...getDataItemByClient(CLIENT, false) }
    case PSE:
      return getDataItemByClient(CLIENT)
    default:
      return { ...dataItemMapRemaining, ...getDataItemByClient(CLIENT) }
  }
}

export const DataItemSortIndexByClient = (CLIENT, trueup = false) => {
  if (CLIENT === NRG_CLIENT && trueup) return NRGTrueupDataItemSortIndex
  switch (CLIENT) {
    case SRP_CLIENT:
      return SRPDataItemSortIndex
    case APS_CLIENT:
      return APSDataItemSortIndex
    case PSE_CLIENT:
      return PSEDataItemSortIndex
    default:
      return dataItemSortIndex
  }
}

const NRGTrueupDataItemSortIndex = {
  rtLmp: 1,
  genMw: 2,
  daLmp: 3,
  daAwardMw: 4,
  rtRevenue: 5,
  daRevenue: 6,
  totalGencost: 7,
  startcostShare: 8,
  totalCost: 9,
  totalCostByGenMW: 10,
  eventtype: 11,
  causecode: 12,
  targetMw: 13,
  availMw: 14,
  lostMwh: 15,
  lostRevDollar: 16,
  unavailMwCost: 17,
  unavailMwCostByLost: 18,
  euor: 19,
  euorMW: 19,
  netdepcap: 20,
  ecoMax: 21,
  ecoMin: 22,
  ecomaxrate: 23,
  ecominrate: 24,
  plantOverPerformance: 25,
  commaOpsEventTrueup: 26,
  commaOpsNonEventTrueup: 27,
  commaOpsDAOppotunityLoss: 28,
  trueupAdj: 29,
  trueUp: 30,
  rsMbLofOpportunity: 31,
  explanation: 32,
}
